import React from "react";
import style from "css/admin/component.module.css";
import SearchItem from "./searchItem";
import SearchDatePicker from "./searchDatePicker";

function SearchDateRange({
    startLabel = "시작일",
    endLabel = "종료일",
    startDate,
    endDate,
    onStartChange,
    onEndChange,
    startPickerProps = {},
    endPickerProps = {},
}) {
    return (
        <div className={style.searchItem_dateRange}>
            <SearchItem label={startLabel}>
                <SearchDatePicker value={startDate} onChange={onStartChange} {...startPickerProps} />
            </SearchItem>
            <div className={style.rangeSeparator_wrapper}>
                <div className={style.rangeSeparator}>~</div>
            </div>
            <SearchItem label={endLabel}>
                <SearchDatePicker value={endDate} onChange={onEndChange} {...endPickerProps} />
            </SearchItem>
        </div>
    );
}

export default SearchDateRange;

